import { useLocale } from 'next-intl';
import Image from '@/components/image';
import FooterTitle from './FooterTitle';
import { sortJSONKeys } from '@/utils/global';
import useGlobalStore from '@/store/global.store';

const PaymentLogos = ({ isMobile, isFromFooter = false }) => {
  const locale = useLocale();
  const isEnglish = locale === 'en';

  const paymentMethods = useGlobalStore((state) => state.paymentMethods);
  const paymentMethodsData = sortJSONKeys(
    paymentMethods?.value?.filter((e) => e?.active) || [],
    isMobile
  );

  const getLocalizedTitle = (item) => {
    return item?.[isEnglish ? 'title-en' : 'title-ar'];
  };

  if (paymentMethodsData?.length === 0) {
    return null;
  }

  return (
    <>
      {isFromFooter && (
        <FooterTitle title='Payment Methods' className='max-lg:text-center' />
      )}

      <div
        className={`my-auto flex flex-wrap gap-1.5 max-lg:mb-3 max-lg:justify-center lg:items-center lg:gap-3 ${!isFromFooter && 'justify-center'}`}
      >
        {paymentMethodsData?.map((payment, index) => {
          const title = getLocalizedTitle(payment);

          return (
            <div key={index} className='relative h-[27px] w-10 max-[380px]:w-6'>
              <Image
                className='absolute inset-0 aspect-auto h-full w-full object-contain text-transparent'
                height={27}
                width={40}
                alt={title || 'Payment method'}
                src={payment?.img}
              />
            </div>
          );
        })}
      </div>
    </>
  );
};

export default PaymentLogos;
